import React__default from 'react';
import BottomSheet from './BottomSheet.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../chunks/bundle-DImSV9VW.js';
import { u as useLocalization } from '../chunks/bundle-CIN9yQRB.js';
import 'react-dom';
import '../chunks/bundle-MyLy9AIu.js';
import '../chunks/bundle-C7jYHvwG.js';
import '../chunks/bundle-DYeeW5nS.js';
import '@sendbird/chat/groupChannel';
import '../utils/message/getOutgoingMessageState.js';
import '../chunks/bundle-CDjVXDOc.js';
import '../chunks/bundle-Dl9NVsui.js';
import '../chunks/bundle-DkviGBGz.js';
import '../chunks/bundle-DUTyBaXr.js';
import '../chunks/bundle-DfDrbjM5.js';
import './IconButton.js';
import './Button.js';
import './Icon.js';
import '@sendbird/uikit-tools';
import '../withSendbird.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../chunks/bundle-4W3uBGU3.js';
import '@sendbird/chat/openChannel';
import '../chunks/bundle-CLonR-iH.js';
import '../useSendbirdStateContext.js';
import '../chunks/bundle-C6-Ix-Lk.js';
import './SortByRow.js';
import '../chunks/bundle-pOZPN8hk.js';

function MobileFeedbackMenu(props) {
    var hideMenu = props.hideMenu, onEditFeedback = props.onEditFeedback, onRemoveFeedback = props.onRemoveFeedback;
    var stringSet = useLocalization().stringSet;
    return (React__default.createElement(BottomSheet, { onBackdropClick: hideMenu },
        React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-options-menu' },
            React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onEditFeedback();
                } },
                React__default.createElement(Label, { type: LabelTypography.BODY_1, color: LabelColors.ONBACKGROUND_1 }, stringSet.EDIT_COMMENT)),
            React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onRemoveFeedback();
                } },
                React__default.createElement(Label, { type: LabelTypography.BODY_1, color: LabelColors.ERROR }, stringSet.REMOVE_FEEDBACK)))));
}

export { MobileFeedbackMenu as default };
//# sourceMappingURL=MobileFeedbackMenu.js.map
